<div class="zapier-slidecast-logo"><img [src]="integration.appLogo" width="300" /></div>
<div class="connecting">Connecting <span class="text-bold-xx-large">{{integration.appName}}</span> to <span class="text-bold-xx-large">Engage (<span style="color:#3fb6dc;">{{user_account}}</span>)</span></div>
<div class="container">
    <div class="wraper-main-section">
        <div class="global-card-section">
            <div>
                <div class="objects objects-below global-header-section">
                    <h5>{{integration.appName}} is requesting access to your Engage account ({{user_account}}). You are giving {{integration.appName}} permissions to:</h5>
                </div>
                <ul class="bullet-ul">
                    <li class="bullets" *ngFor="let s of scope">{{s.scopeDescription}}</li>
                </ul>
                <div class="objects objects-below" *ngIf="connected">
                    <div class="object-center">
                        Please Note: this account is already connected to {{integration.appName}}. <span style="color:red">Clicking 'Connect' may disconnect any active Zaps using this connection.</span>
                    </div>
                </div>
                <div class="objects objects-below">
                    <div class="object-center">
                        <span>Please click 'Connect' if you agree.</span>
                    </div>
                </div>
            </div>
            <div class="bottom-section">
                <div class="row">
                    <div class="form-group buttons">
                        <button class="btn btn-primary" (click)="connect()" [disabled]="redirect_uri == ''">Connect</button>
                        <button class="btn btn-cancel" (click)="cancel()" [disabled]="redirect_uri == ''">Cancel</button>
                    </div>
                </div>
            </div>
            <div class="bottom-section">
                <div class="row">
                    <div class="form-group buttons">
                        If you would like to connect to another account, please <a style="color:#3fb6dc; font-weight: bold;" (click)="relogin()">login here</a>.
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
